/**
 * en-GB messages added by Phase 2 task S17 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s17EnGB = {
    'nav.section.reports': 'Reports',
    'nav.reports.history': 'History',
    'nav.reports.timesheet': 'Timesheets',
    'error.export_too_large': 'That export is too large (over {max} rows). Choose a shorter date range or fewer filters.',
    'error.reports_range_invalid': 'Choose a valid date range within the allowed length.',
    'error.reports_no_recipients': 'Add at least one recipient for the on-site report first.',
    'reports.yes': 'Yes',
    'reports.no': 'No',
    'reports.still_in': 'Still in',
    'reports.col.name': 'Name',
    'reports.col.person': 'Person',
    'reports.col.site': 'Site',
    'reports.col.sites': 'Sites',
    'reports.col.group': 'Group',
    'reports.col.host': 'Host',
    'reports.col.date': 'Date',
    'reports.col.signed_in': 'Signed in',
    'reports.col.signed_out': 'Signed out',
    'reports.col.site_time': 'site time',
    'reports.col.minutes': 'Minutes',
    'reports.col.sign_in_method': 'Sign-in method',
    'reports.col.sign_out_method': 'Sign-out method',
    'reports.col.flags': 'Flags',
    'reports.col.protected': 'Protected',
    'reports.col.time_zone': 'Time zone',
    'reports.col.total_minutes': 'Total minutes',
    'reports.col.total_hours': 'Total (h:mm)',
    'reports.col.first_in': 'First in',
    'reports.col.last_out': 'Last out',
    'reports.col.record_id': 'Record id',
    'reports.on_site.subject': 'Still on site at {site} on {date}: {count}',
    'reports.on_site.intro': 'These {count} people are still signed in at {site} on {date}.',
    'reports.on_site.none': 'Nobody is signed in at {site} on {date}.',
    'settings.reports.onSiteReport.enabled': 'Email the on-site report each day',
    'settings.reports.onSiteReport.time': 'Time to send it (site time)',
    'settings.reports.onSiteReport.recipients': 'Send it to',
    'settings.reports.onSiteReport.groupIds': 'Only these groups (none = all groups)',
    'settings.reports.onSiteReport.weekdaysOnly': 'Weekdays only',
    'settings.reports.onSiteReport.sendWhenEmpty': 'Send it even when nobody is on site',
    'settings.reports.maxExportRows': 'Largest export (rows)',
};
//# sourceMappingURL=s17.js.map